import { SRListFilterBox } from '@sr/ui'

export const Filters = () => {
  return <SRListFilterBox onClear={() => ({})}>{<div></div>}</SRListFilterBox>
}
